var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessTimeOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.99 2.12695C6.47 2.12695 2 6.60695 2 12.127C2 17.647 6.47 22.127 11.99 22.127C17.52 22.127 22 17.647 22 12.127C22 6.60695 17.52 2.12695 11.99 2.12695ZM12 20.127C7.58 20.127 4 16.547 4 12.127C4 7.70695 7.58 4.12695 12 4.12695C16.42 4.12695 20 7.70695 20 12.127C20 16.547 16.42 20.127 12 20.127ZM11.78 7.12695H11.72C11.32 7.12695 11 7.44695 11 7.84695V12.567C11 12.917 11.18 13.247 11.49 13.427L15.64 15.917C15.98 16.117 16.42 16.017 16.62 15.677C16.83 15.337 16.72 14.887 16.37 14.687L12.5 12.387V7.84695C12.5 7.44695 12.18 7.12695 11.78 7.12695Z",
    fill: "#6200ea"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessTimeOutline);
export default __webpack_public_path__ + "static/media/access_time_outline.5bbf02adea2e7b295de68af11ed4eef5.svg";
export { ForwardRef as ReactComponent };